module.exports = __webpack_public_path__ + "img/hohlschnitt_grau_candy.0f877d8a.jpg";